import { render, staticRenderFns } from "./OneSidebarHeader.vue?vue&type=template&id=87858bf2&scoped=true&lang=pug&"
import script from "./OneSidebarHeader.vue?vue&type=script&lang=ts&"
export * from "./OneSidebarHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OneSidebarHeader.vue?vue&type=style&index=0&id=87858bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87858bf2",
  null
  
)

export default component.exports